import { QueryKey } from "@tanstack/react-query";
import ButtonRemove from "components/ui/ButtonRemove";
import { useMessages } from "hooks/useMessages";
import { useRemoveResource } from "hooks/useRemoveResource";

interface ButtonRemoveResourceProps {
  id: string;
  pathName: string;
  queryKey: string | QueryKey | QueryKey[];
  message?: string;
}

export default function ButtonRemoveResource({
  id,
  pathName,
  message,
  queryKey,
}: ButtonRemoveResourceProps) {
  const { onError, onSuccess } = useMessages({
    success: "Registro removido com sucesso!",
  });

  const { onRemoveResource, isPending } = useRemoveResource({
    pathName,
    queryKeyToInvalidate: queryKey,
    onError: (error) => onError(error?.response?.data?.message),
    onSuccess,
  });
  return (
    <ButtonRemove
      onClick={() => onRemoveResource({ id })}
      isLoading={isPending}
      message={message}
    />
  );
}
